@if (isOpen) {
  <button type="button" class="feedback-backdrop" aria-label="Close feedback drawer" (click)="closeDrawer()"></button>
}

<div class="feedback-shell" [class.open]="isOpen">
  <button
    type="button"
    class="feedback-tab"
    [attr.aria-expanded]="isOpen"
    aria-controls="feedback-panel"
    (click)="toggleDrawer()"
  >
    <i class="bi" [class.bi-chat-right-text]="!isOpen" [class.bi-x-lg]="isOpen"></i>
    <span>Feedback</span>
  </button>

  <section class="feedback-panel" id="feedback-panel" aria-label="Feedback drawer">
    <div class="feedback-panel__header">
      <div>
        <div class="feedback-eyebrow">Found something?</div>
        <h2>Tell us what to fix</h2>
        <p>Send a ticket straight into the Machine feedback board and we will triage it from there.</p>
      </div>
      <button type="button" class="btn btn-sm btn-light" [disabled]="isSubmitting" (click)="closeDrawer()">Close</button>
    </div>

    <div class="feedback-form">
      <div>
        <label class="form-label" for="feedback-title">Title</label>
        <input
          id="feedback-title"
          class="form-control"
          maxlength="140"
          placeholder="Short summary of what should change"
          [(ngModel)]="form.title"
        />
      </div>

      <div>
        <label class="form-label" for="feedback-description">Description</label>
        <textarea
          id="feedback-description"
          class="form-control"
          rows="8"
          maxlength="4000"
          placeholder="What happened, what should happen instead, and any useful context"
          [(ngModel)]="form.description"
        ></textarea>
      </div>

      <div class="feedback-hint">
        We automatically include the current route so it is easier to trace where this feedback came from.
      </div>

      <button type="button" class="btn btn-primary submit-button" [disabled]="!canSubmit" (click)="submit()">
        @if (!isSubmitting) {
          Submit feedback
        } @else {
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span>Submitting...</span>
        }
      </button>
    </div>
  </section>
</div>
